//CustomEvent for IE 9+
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {	
  // polyfill for replaceChildren
  if( Node.prototype.replaceChildren === undefined) {
    Node.prototype.replaceChildren = function(addNodes) {
      while(this.lastChild) {
        this.removeChild(this.lastChild); 
      }
      if (addNodes !== undefined) {
        this.append(addNodes); // phpcs:ignore
      }
    }
  }
}());